<template>
  <modal
    :show.sync="isOpenLocal"
    scrollable
    header-classes="bg-primary p-2 flex items-center"
    size="lg"
    @close="handleClose"
  >
    <!-- <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Add News
    </h6> -->
    <h6 class="modal-title text-black fsize20 font-semibold">
      Personal Details
    </h6>
    <div>
      <div class="my-2 md:flex">
        <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
          <p class="input-title-black">First Name</p>
          <base-input
            v-model="fname"
            placeholder="Enter First Name"
            name="First Name"
            class="cust-form-border"
          ></base-input>
        </div>
        <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
          <p class="input-title-black">Last Name</p>
          <base-input
            name="Last Name"
            v-model="lname"
            placeholder="Enter Last Name"
            class="cust-form-border"
          ></base-input>
        </div>
      </div>
      <div class="md:flex">
        <div class="md:w-1/2 lg:w-1/2 w-full md:pt-4 pt-0">
          <p class="input-title-black">Email</p>
          <base-input
            name="Email"
            v-model="email"
            placeholder="Enter your EmailID"
            class="cust-form-border"
          ></base-input>
        </div>
        <div class="md:w-1/2 lg:w-1/2 w-full md:pt-4 pt-0 md:pl-4">
          <p class="input-title-black">Phone</p>
          <base-input
            name="mobile"
            v-model="mobile"
            placeholder="Enter your Phone no."
            class="cust-form-border"
          ></base-input>
        </div>
      </div>
      <div class="my-2 md:flex">
        <div class="md:w-1/2 lg:w-1/2 w-full md:pt-4 pt-0">
          <p class="input-title-black">Location</p>
          <base-input
            v-model="location"
            placeholder="Enter Location Name"
            name="Location Name"
            class="cust-form-border"
          ></base-input>
        </div>
        <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
          <p class="input-title-black">Designation</p>
          <!-- <b-form-select>
            v-model="designation" :options= "users" class="text-base text-black"
          </b-form-select> -->
          <base-input
            v-model="designation"
            placeholder="Enter your designation "
            name="designation"
            class="cust-form-border"
          ></base-input>
        </div>
      </div>
      <div class="my-2 md:flex">
        <div class="md:w-1/2 lg:w-1/2 w-full md:pt-4 pt-2">
          <p class="input-title-black">Signature</p>
          <base-input
            v-model="signature"
            placeholder="Enter Signature"
            name="Signature Name"
            class="cust-form-border"
          ></base-input>
        </div>
      </div>
    </div>
    <template slot="footer" class="justify-center">
      <base-button type="primary" @click="handleClick(data.role)"
        >SAVE CHANGES</base-button
      >
      <base-button type="secondary" class="ml-auto border" @click="handleClose"
        >CLOSE</base-button
      >
    </template>
  </modal>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      fname: "",
      lname: "",
      email: "",
      mobile: "",
      location: "",
      signature: "",
      designation: "",
      // users: [
      //   { value: null, text: "select designation", disable: "true" },
      //   "Student",
      //   "Teacher",
      // ],
    };
  },

  props: {
    isOpen: Boolean,
    data: { type: Object },
  },
  computed: {
    isOpenLocal: {
      get() {
        return this.isOpen;
      },
      set(val) {
        if (!val) {
          this.handleClose();
        }
      },
    },
    ...mapState("student", { studentLearning: "studentLearning" }),
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleClick(role) {
      if (role === "student") {
        this.editStudentDetail();
      } else {
        this.editAuthorDetail();
      }
    },
    async editStudentDetail() {
      const payload = {
        location: this.location,
        email: this.email,
        mobile: this.mobile,
        designation: this.designation,
        signature: this.signature,
        firstname: this.fname,
        lastname: this.lname,
        _id: this.data._id,
      };
      const payload2 = {
        userId: this.data._id,
      };
      const data = await this.$store.dispatch("student/editStudents", payload);

      if (data.code == 200) {
        // console.log(data.data);
        await this.$store.commit("auth/UPDATE_USERDATA_INFO", data.data);
      }
      this.handleClose();
    },
    async editAuthorDetail() {
      const payload = {
        location: this.location,
        email: this.email,
        mobile: this.mobile,
        designation: this.designation,
        signature: this.signature,
        firstname: this.fname,
        lastname: this.lname,
        _id: this.data._id,
      };
      const payload2 = {
        userId: this.data._id,
      };
      const data = await this.$store.dispatch("student/editStudents", payload);
      // eLearning/editUser

      if (data.code == 200) {
        // console.log(data.data);
        await this.$store.commit("auth/UPDATE_USERDATA_INFO", data);
      }
      this.handleClose();
    },
    Email() {
      this.email = this.data.email;
    },
    Mobile() {
      this.mobile = this.data.mobile;
    },
    Location() {
      if (this.userData.student) {
        this.location = this.data.student.location;
      } else {
        this.location = this.data.location;
      }
    },
    designations() {
      if (this.userData.student) {
        this.designation = this.data.student.designation;
      } else {
        this.designation = this.data.designation;
      }
    },
    Signature() {
      this.signature = this.studentLearning[0].signature;
    },
    firstName() {
      this.fname = this.data.firstname;
    },
    lastName() {
      this.lname = this.data.lastname;
    },
  },
  mounted() {
    this.Email();
    this.Mobile();
    this.Location();
    this.designations();
    this.firstName();
    this.lastName();
    this.Signature();
  },
};
</script>
